import React from 'react';
import PropTypes from 'prop-types';
import { isString } from 'lodash';

import { ContentZonesService, LocaleService } from '@sm360/widget-commons-core-services';
import { CONSTANT, Account, ModalService, AdobeService, ADOBE_TAGS } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import ConfigsService from 'login/services/ConfigsService/ConfigsService.js';

import SignUpForm from 'login/components/SignUp/SignUpForm/SignUpForm.jsx';
import InformationZone from 'login/components/Library/InformationZone/InformationZone.jsx';
import ModalHeader from 'login/components/Library/ModalHeader/ModalHeader.jsx';
import FacebookBtn from 'login/components/Library/FacebookBtn/FacebookBtn.jsx';
import Separator from 'login/components/Library/Separator/Separator.jsx';
import PrivacyPolicy from 'login/components/Library/PrivacyPolicy/PrivacyPolicy.jsx';

import { SAVE_CONFIRMATION, SIGN_UP as MODAL, LOGIN as SIGN_IN } from 'login/constants/modalNames.js';

import 'login/components/SignUp/SignUpModal.scss';

const czGroupName = 'widget.login.forms.signup';

class SignUpContent extends React.Component {
    constructor() {
        super();
        this.modal = ModalService.get(MODAL);
        this.signIn = ModalService.get(SIGN_IN);
        this.saveConfirmation = ModalService.get(SAVE_CONFIRMATION);

        this.headerTitleCz =
            ContentZonesService.getContentZone(czGroupName, 'maintext') &&
            ContentZonesService.getContentZone(czGroupName, 'maintext').getText();
        this.headerTextCz =
            ContentZonesService.getContentZone(czGroupName, 'subtext') &&
            ContentZonesService.getContentZone(czGroupName, 'subtext').getText();
        this.modalImageUrl =
            ContentZonesService.getContentZone(czGroupName, 'image') &&
            ContentZonesService.getContentZone(czGroupName, 'image').getValue();

        this.hideFacebook =
            ContentZonesService.getContentZone('widget.login.popup', 'widget.login.popup.facebook.disable') &&
            ContentZonesService.getContentZone(
                'widget.login.popup',
                'widget.login.popup.facebook.disable'
            ).getText() === 'true';

        this.handleSwitchToSignIn = this.handleSwitchToSignIn.bind(this);
        this.switchToConfirmation = this.switchToConfirmation.bind(this);
    }

    handleSwitchToSignIn() {
        this.signIn.addOnCloseCallbackFromAnotherModal(this.modal);
        this.signIn.open({ context: 'widget.login.signin.information', hasConfirmation: this.props.hasConfirmation });
        this.modal.close(true);
        if (this.props.hasAdobeTagging) {
            AdobeService.eventTrigger(ADOBE_TAGS.CREATE_AN_ACCOUNT_CTA(CONSTANT.ACCOUNT.LOGIN), 'global-onclick');
        }
    }

    switchToConfirmation() {
        this.saveConfirmation.addOnCloseCallbackFromAnotherModal(this.modal);
        this.saveConfirmation.open({ context: 'widget.login.signup.information' });
        this.modal.close(true);
    }

    render() {
        const classUtil = isString(this.props.classParam) ? this.props.classParam : '';
        const loginBlock = !this.hideFacebook &&
            ConfigsService.getFacebookAppId() && (
                <div>
                    <div className="fb-login">
                        <FacebookBtn
                            closeDialog={this.props.hasConfirmation ? this.switchToConfirmation : this.modal.close}
                            quote={this.props.quote}
                        />
                    </div>
                    <Separator />
                </div>
            );
        return (
            <div className={`modal-login-content ${classUtil}`}>
                <div className="SignUpForm">
                    <ModalHeader
                        titleContentZone={this.headerTitleCz}
                        textContentZone={this.headerTextCz}
                        showImage={false}
                        showText
                    />

                    {loginBlock}

                    <SignUpForm
                        closeDialog={
                            this.props.hasConfirmation
                                ? this.switchToConfirmation
                                : (params) => this.modal.close(false, params)
                        }
                        account={this.props.account}
                        quote={this.props.quote}
                        submitLead={this.props.submitAccountCreationLead}
                        hasAdobeTagging={this.props.hasAdobeTagging}
                    />
                    <div className="form-login-other">
                        {LocaleService.t('LOGIN.ALREADY_HAVE_ACCOUNT')}
                        <button onClick={this.handleSwitchToSignIn} className="sr-link">
                            {LocaleService.t('LOGIN.LOGIN_TO_EXISTING_ACCOUNT')}
                        </button>
                    </div>
                    <PrivacyPolicy />
                </div>
                <InformationZone groupName={this.props.context} czOldImage={this.modalImageUrl} />
            </div>
        );
    }
}
SignUpContent.defaultProps = {
    classParam: null,
    context: 'widget.login.signup.information',
    hasConfirmation: false,
    account: new Account(),
    quote: new Quote.QuoteModel(),
    submitAccountCreationLead: true,
    hasAdobeTagging: false,
};

SignUpContent.propTypes = {
    context: PropTypes.string,
    classParam: PropTypes.string,
    submitAccountCreationLead: PropTypes.bool,
    hasConfirmation: PropTypes.bool,
    account: PropTypes.instanceOf(Account),
    quote: PropTypes.instanceOf(Quote.QuoteModel),
    hasAdobeTagging: PropTypes.bool,
};

SignUpContent.displayName = 'SignUpContent';

export default SignUpContent;
